import React,{useState} from 'react'
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';

import PagesAdmin from '../../CmsComponents/PagesAdmin';

function Webpages() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <PagesAdmin isOpen={isOpen} />
        </div>
    )
}
export default Webpages